import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import CliCommands from "components/NodeDetail/shared/CliCommands";
import { Capability } from "models/Capability.model";
import CloudflareHTTPPorts from "./HTTPPorts/Cloudflare";
import SSHAccess from "./SSHAccess";
import CloudFirewallPortsSection from "./CloudFirewallPortsSection";
import { Environment } from "components/Environment/utils/types";
import SkybridgeHTTPPorts from "./HTTPPorts/Skybridge";
import EnvironmentNetworkSection from "./Network";
import { NodeDetailSection } from "components/NodeDetail/shared/NodeDetailSection";
import {
  shouldScrollToSshAccess,
  type SshAccessNavigationState,
} from "components/Environment/shared/sshAccessNavigation";
interface AccessSettingsProps {
  environment: Environment;
  workspaceCapabilities: Capability[];
  refetchEnvironment?: () => Promise<unknown>;
}
const AccessSettings: React.FC<AccessSettingsProps> = (props) => {
  const location = useLocation<SshAccessNavigationState>();
  const sshAccessSectionRef = useRef<HTMLElement>(null);
  const isSkybridgeEnabled =
    props.environment.labels?.["tunnel-provider"] === "skybridge";
  const hasExistingFirewallPorts = Boolean(
    props.environment.instance?.firewall_rules?.ingress_rules?.length,
  );
  const shouldShowFirewallPorts =
    !isSkybridgeEnabled || hasExistingFirewallPorts;

  useEffect(() => {
    if (shouldScrollToSshAccess(location.hash, location.state)) {
      sshAccessSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [location.hash, location.state]);

  return (
    <>
      {isSkybridgeEnabled ? (
        <SkybridgeHTTPPorts environment={props.environment} />
      ) : (
        <NodeDetailSection title="HTTP Ports" className="mt-8">
          <CloudflareHTTPPorts
            environment={props.environment}
            capabilities={props.workspaceCapabilities}
          />
        </NodeDetailSection>
      )}
      {shouldShowFirewallPorts && (
        <NodeDetailSection
          title={isSkybridgeEnabled ? "Cloud Firewall Ports" : "TCP/UDP Ports"}
        >
          <CloudFirewallPortsSection
            environment={props.environment}
            capabilities={props.workspaceCapabilities}
            refetchEnvironment={props.refetchEnvironment}
          />
        </NodeDetailSection>
      )}
      <NodeDetailSection title="Network">
        <EnvironmentNetworkSection environment={props.environment} />
      </NodeDetailSection>
      <NodeDetailSection
        id="Access"
        ref={sshAccessSectionRef}
        className="scroll-mt-6"
        title="Share SSH Access"
      >
        <SSHAccess
          environment={props.environment}
          refetchEnvironment={props.refetchEnvironment}
        />
      </NodeDetailSection>
      <NodeDetailSection title="Using Brev CLI (SSH)">
        <CliCommands
          name={props.environment.name || ""}
          resourceNoun="instance"
          userId={props.environment.labels?.userId || ""}
        />
      </NodeDetailSection>
    </>
  );
};

export default AccessSettings;
